var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArchway(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M552 48C565.255 48 576 37.255 576 24V24C576 10.745 565.255 0 552 0H24C10.745 0 0 10.745 0 24V24C0 37.255 10.745 48 24 48H32V464H24C10.745 464 0 474.745 0 488V488C0 501.255 10.745 512 24 512H176C184.837 512 192 504.837 192 496L192 323.225C192 274.414 227.069 230.917 275.494 224.793C334.066 217.385 384 262.886 384 320V496C384 504.837 391.163 512 400 512H552C565.255 512 576 501.255 576 488V488C576 474.745 565.255 464 552 464H544V48H552ZM496 48V88H80V48H496ZM432 464V320C432 240.625 367.375 176 288 176S144 240.625 144 320V464H80V136H496V464H432Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchway);
export default __webpack_public_path__ + "static/media/archway.9c2bfe1ac2c8a5d2c259383acc0d0cd7.svg";
export { ForwardRef as ReactComponent };